"use strict";

module.exports = require("./is-implemented")() ? Object.assign : require("./shim");



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es5-ext/object/assign/index.js
// module id = ../../../node_modules/es5-ext/object/assign/index.js
// module chunks = 1